import { useNavigate } from 'react-router-dom';

export default function HeroSection() {
  const navigate = useNavigate();

  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat pt-24 sm:pt-20"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://public.readdy.ai/ai/img_res/b9f993fbcd900b61ef2f4aca948db89a.jpg')`
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white w-full">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold mb-6 leading-tight">
            AI로 만드는<br />
            <span className="text-teal-400">완벽한 마케팅퍼널</span>
          </h1>
          <p className="text-xl md:text-2xl mb-8 text-gray-200 leading-relaxed">
            비즈니스 모델을 분석하여 최적화된 마케팅 퍼널을 자동으로 생성합니다.<br />
            몇 분 안에 전문가 수준의 마케팅 전략을 구축하세요.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
            <button 
              onClick={() => navigate('/funnel-generator')}
              className="bg-teal-600 hover:bg-teal-700 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              퍼널 생성하기
            </button>
            <button className="border-2 border-white text-white hover:bg-white hover:text-gray-900 px-8 py-4 rounded-lg text-lg font-semibold transition-all whitespace-nowrap cursor-pointer">
              데모 보기
            </button>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
              <div className="w-12 h-12 bg-teal-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-robot-line text-2xl text-white"></i>
              </div>
              <h3 className="text-lg font-semibold mb-2">AI 자동 생성</h3>
              <p className="text-gray-200">비즈니스 정보만 입력하면 AI가 최적의 퍼널을 자동으로 설계합니다</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
              <div className="w-12 h-12 bg-teal-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-line-chart-line text-2xl text-white"></i>
              </div>
              <h3 className="text-lg font-semibold mb-2">실시간 최적화</h3>
              <p className="text-gray-200">성과 데이터를 분석하여 퍼널을 지속적으로 개선합니다</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
              <div className="w-12 h-12 bg-teal-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-rocket-line text-2xl text-white"></i>
              </div>
              <h3 className="text-lg font-semibold mb-2">빠른 구축</h3>
              <p className="text-gray-200">복잡한 마케팅 퍼널을 5분 안에 완성하고 바로 실행할 수 있습니다</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
